import apiUrl from '../../../constants';
import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { variables } from '../../../../config'

import { newAWB, RecReasonData } from '../../../services/getDataCall';
import { AWBNumberNormslization } from '../../../services/utility';
import { custom_sort } from '../../../services/utility';
import { getNoOfDaysFromCurrentDate } from '../../../services/DateCalcFuntion';
import { mpsDetails } from '../../../services/mpsDetails';
import { createShipmentSummaryAccess } from '../../../common/shipmentSummaryAccess';

export default {
  name: 'InvestigationDefault',
  props: ['rootMethods'],
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data() {
    return {
      newhubs: '',
      newhublist: [],
      show: false,
      show1: false,
      show2: false,
      //verification Status
      vStatus: '',
      vStatusList: [],
      //hub list
      Status: '',
      StatusList: [],
      //for hun list
      hub: '',
      hublist: [],
      //pending at
      pendingAt: '',
      pendingAtList: [],
      myStr: '',
      //bag no
      bag_no: '',
      manifestFromDate: '',
      manifestToDate: '',
      investigationStatus: '',
      investigationStatusOptions: [
        { id: 'open', label: 'Open' },
        { id: 'close', label: 'Close' }
      ],
      todate: '',
      fromdate: '',
      shortagetype: '',
      shortagetypes: [{
        id: 'BagShortage',
        label: 'BagShortage'
      }, {
        id: 'Shortage',
        label: 'Shortage'
      }],
      octroi_MRP: '',
      awbnumber: '',
      accesszonelist: '',
      parsedata: '',
      isLoading1: false,
      pagecount: 1,
      listUserData: [],
      totalRows: '',

      tablehublist: [],
      currenthubname: '',
      originhubname: '',
      finaldestinationname: '',
      bucketname: '',
      Shortagetypelist: [],
      regionname: '',

      //client list
      clienList: [],
      hubdroplist: [],
      bucketList: [],
      pendingday: '',
      operator: '',
      operatorOptions: [
        { id: '1', label: '>' },
        { id: '2', label: '<' },
        { id: '3', label: '=' }
      ],
      editshowtable: false,
      isactive: null,
      exportdis: '',
      List: [],
      imagePathData: '',
      abc: '',
      primaryKey: '',
      imgData: '',
      showModal: false,
      ListData: [],
      errormsg: '',
      isLoadingimg: false,
      totalcount: 0,
      subStatusList: [],
      recreasons: [],
      Awb: [],
      RECReasonMap: {},
      checkboxWarning : '',
      sortingDate:'',
      showSort:false,
      isMpsDetails: false,
      mpsDetailsShipments: [],
      isMpsDetailsLoading: false,
      sortColumn: null,
      sortDirection: null,
      priority: "",
      priorityOptions: [
        { id: 'P1', label: 'P1' },
        { id: 'P2', label: 'P2' },
        { id: 'P3', label: 'P3' },
      ],
    }
  },
  mounted() {
    this.getMapping()
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.accesszonelist = window.localStorage.getItem('accesszone');
    this.parsedata = JSON.parse(this.accesszonelist);
    this.getzonehubs();
    this.pendingat();
    this.status();
    this.verificationStatus();
    this.recReasonFetchData()
    this.pageno = 0;
    this.sortColumn = null;
    this.sortDirection = null;
  },

  computed: {
    checkDisabled: function () {
      const selectedOperator = this.operator && this.operator.id ? this.operator.id : this.operator;
      return selectedOperator === '' || selectedOperator === null || selectedOperator === undefined;
    },
    ExportDisableds: function () {
      return (this.exportdis == '') ? true : false;
    },
    ShortageDisableds: function () {
      return (this.Status.statusname == 'Shortage') ? false : true;
    },
    DisabledsAllFeild: function () {
     // this.isactive = false;
      this.checkboxWarning = ''
      return (this.awbnumber == '') ? false : true;
    },
    sortedList() {
      if (!this.sortColumn) return this.listUserData;

      return [...this.listUserData].sort((a, b) => {
        const isAscending = this.sortDirection === "asc";
        const valueA =
          this.sortColumn === "netvalue" ? parseFloat(a[this.sortColumn]) : a[this.sortColumn];
        const valueB =
          this.sortColumn === "netvalue" ? parseFloat(b[this.sortColumn]) : b[this.sortColumn];

        if (valueA > valueB) {
          return isAscending ? 1 : -1;
        } else if (valueA < valueB) {
          return isAscending ? -1 : 1;
        }
        return 0;
      });
    },
  },

  methods: {
    async getMapping() {
      this.mappingList = await this.rootMethods();
    },
    isActiveCheck(event){      
      this.isactive = event.target.checked;
      if(event.target.checked) {
        this.checkboxWarning = "Active investigation shipments will be displayed";
        return;
      }
      this.checkboxWarning = "Closed investigation shipments will be displayed";
    },
    sortingEvent(event,sortValue){
      if(sortValue == 'Asc') {
        this.sortingDate=true
        this.searchData()
        return
      }
      this.sortingDate=false
      this.searchData()

    },
    getzonehubs() {
      this.show = true;

      axios({
        method: 'post',
        url: apiUrl.api_url + 'getZoneList',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        if(result.data.code===200){
          // let finalHubData = []
        // result.data.data.forEach((hub) => {
        //   finalHubData.push({
        //     id: hub.hubzoneid,
        //     label: hub.hubzonename
        //   })
        // })
        this.newhublist =  result.data.data
        this.show = false;
      }else{
        this.$alertify.error(result.data.message)
        this.show = false;
      }
      },
        error => {
          this.show = false;
          console.error(error)
        })
    },

    callHub(newhublist) {
      this.hublist = []

      this.getHubList(newhublist.hubzoneid)
      this.hub = ''
      if (newhublist.hubzoneid != undefined) {
        this.getHubList()
      }
    },

    getHubList(id) {
      let finalhublist = []
      for (let i = 0; i < this.parsedata.hubaccess.length; i++) {
        if (id == this.parsedata.hubaccess[i]["HubZoneId"]) {

          finalhublist.push({
            id: this.parsedata.hubaccess[i]["HubID"],
            label: this.parsedata.hubaccess[i]["HubName"]
          })
          this.hublist = finalhublist;

        }
      }


    },
    status() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'status',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        if(result.data.code===200){
          this.StatusList=result.data.data;
          // let statusdata = []
        // result.data.data.forEach((status) => {
        //   statusdata.push({
        //     id: status.statuscode,
        //     label: status.statusname
        //   })
        // })
        // this.StatusList = statusdata
        }else{
          this.$alertify.error(result.data.message)
        }
        
      },
        error => {

          console.error(error)
        })
    },




    verificationStatus() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'allVerificationStatus',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        if(result.data.code===200){
          this.vStatusList=result.data.data;
          // let vstatusdata = []
          // result.data.data.forEach((x) => {
          //   vstatusdata.push({
          //     id: x.investigationactionmasterid,
          //     label: x.actionname
          //   })
          // })
          // this.vStatusList = vstatusdata
        }else{
          this.$alertify.error(result.data.message)
        }
      },
        error => {

          console.error(error)
        })

    },

    pendingat() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'getinvestigationbuckettype',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
          if(result.data.code===200){
              // let array = []
              // result.data.data.forEach((x) => {
              //   array.push({
              //     id: x.investigatbuckettypeid,
              //     label: x.buckettypename
              //   })
              // })
              this.pendingAtList = result.data.data
        }else{
          this.$alertify.error(result.data.message)
        }
      },
        error => {
          console.error(error)
        })
    },
    resetForm(reset) {
      if (reset != 1) {
        this.$validator.reset(); 
        this.errors.clear();
        this.listUserData = [];
        this.pageno = 0; this.totalcount = ''; 
        this.pagecount = 1; this.totalRows = '';
        this.awbnumber = ''
        this.isLoading1 = false;
      }
      this.Status = this.exportdis = this.octroi_MRP = this.vStatus = this.hub = this.newhubs = this.pendingAt = this.todate = this.fromdate = this.manifestFromDate = this.manifestToDate = this.investigationStatus = this.shortage_type = this.priority = ''; 
      this.isactive = null;
      this.checkboxWarning = '';
      this.sortColumn= null;
      this.sortDirection= null;
    },
    searchUserData() {
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.searchData();
    },
    //to get pagination
    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * variables.pageRecordLimit
      this.searchData(this.pageno)
    },
    validateSearchFilters() {
      const formats = /[`!@#$%^&*()_+\-=\[\]{};':"\\|.<>\/?~]/
      if (formats.test(this.awbnumber)) {
        this.$alertify.error("Please Search Comma Seprated Shippingids")
        return false;
      }

      if ((this.fromdate && !this.todate) || (!this.fromdate && this.todate)) {
        this.$alertify.error("Please enter both  date")
        return false;
      }

      if (this.fromdate > this.todate) {
        this.$alertify.error("From date should not be greater than To date")
        return false;
      }

      if ((this.manifestFromDate && !this.manifestToDate) || (!this.manifestFromDate && this.manifestToDate)) {
        this.$alertify.error("Please enter both shipment manifest dates")
        return false;
      }

      if (this.manifestFromDate > this.manifestToDate) {
        this.$alertify.error("Shipment manifest from date should not be greater than to date")
        return false;
      }

      return true;
    },
    buildSearchPayload(pageNo = 0, options = {}) {
      const { includePagination = true, exportData = false } = options;
      const vstatusid = this.vStatus.investigationactionmasterid
        ? this.vStatus.investigationactionmasterid.toString()
        : undefined;
      const bucketid = this.pendingAt.investigatbuckettypeid
        ? this.pendingAt.investigatbuckettypeid.toString()
        : undefined;

      const payload = {
        shippingid: this.awbnumber,
        FromDate: this.fromdate,
        ToDate: this.todate,
        status: this.Status.statuscode,
        actionstatuscode: vstatusid,
        hubzoneid: this.newhubs.hubzoneid,
        currenthubid: this.hub.id,
        operator: this.operator && this.operator.id ? this.operator.id : this.operator,
        netvalue: this.octroi_MRP,
        buckettypecode: bucketid,
        bagno: this.bag_no,
        shortagetype: this.shortagetype.id,
        sortingDate: this.sortingDate,
        priority: this.priority.id
      };

      if (includePagination) {
        payload.offset = pageNo;
        payload.limit = variables.pageRecordLimit;
      }

      if (exportData) {
        payload.exportdata = true;
      }

      if (this.manifestFromDate && this.manifestToDate) {
        payload.frommanifesteddate = `${this.manifestFromDate.slice(0, 10)} 00:00:00`;
        payload.tomanifesteddate = `${this.manifestToDate.slice(0, 10)} 23:59:59`;
      }

      const selectedInvestigationStatus =
        this.investigationStatus && this.investigationStatus.id
          ? this.investigationStatus.id
          : this.investigationStatus;
      if (selectedInvestigationStatus) {
        payload.investigationstatus = selectedInvestigationStatus === 'open';
      }

      if (typeof this.isactive === 'boolean') {
        payload.isactive = this.isactive;
      }

      return payload;
    },
    //searchbutton
    searchData(pageNo = 0) {
      this.sortColumn = null;
      this.sortDirection = null
      this.awbnumber = AWBNumberNormslization(this.awbnumber).toString();
      if(this.Status.statuscode == 20){
        this.showSort =true

      }
      this.isLoading1 = true
      this.show2 = true;
      this.totalcount = 0
      this.listUserData = [];
      this.pagecount = 1;
      this.totalRows = '';
      this.exportdis = 1;
      if (!this.validateSearchFilters()) {
        this.show2 = false;
        this.isLoading1 = false;
        return;
      }

      if ((this.fromdate && this.todate) || (!this.fromdate && !this.todate)) {
        if (this.awbnumber != '') {
          this.resetForm(1)
          this.exportdis = 1;
        }

        this.input = this.buildSearchPayload(pageNo, { includePagination: true });

        axios({
          method: 'post',
          url: apiUrl.api_url + 'searchinvestigationshipmentData',
          data: this.input,
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }
        }).then(result => {
            if(result.data.code===200){
                this.show2 = false
              this.listUserData = Array.isArray(result.data.data) ? result.data.data : [];
              this.totalcount = typeof result.data.count === 'number' ? result.data.count : this.listUserData.length
              if (this.totalcount == undefined) {
                this.totalcount = this.listUserData.length
              }
              if (!this.listUserData.length) {
                this.isLoading1 = false;
                this.$alertify.error('No records found for the selected search filters');
              }
              console.log(this.listUserData,"this.listUserDat............");
              
              this.NewAwb(this.listUserData);
              this.getDisputeStatusName(result.data.data);
              this.getClientList();
              this.gethubdropdown();
              this.getpendingat();
              this.pendingDays();
              this.getregionname();
              this.Statusname();
              this.buckettypecode()
              this.verificationStatusList()
              this.Recreasion()
              if (this.totalcount < variables.pageRecordLimit) {
                this.pagecount = 1
              } else {
                this.pagecount = Math.ceil(this.totalcount / variables.pageRecordLimit)
              }
          }else{
            this.show2 = false
            this.isLoading1 = false
            this.$alertify.error(result.data.message)
          }
        }).catch(error => {
          this.show2 = false;
          this.isLoading1 = false;
          console.error(error);
          this.$alertify.error('Something went wrong while fetching shipment details');
        })
      }
    },

    getDisputeStatusName(data) {
      let i = 0;
      for (let d of data) {
        if (d.disputestatuscode !== null && d.disputestatuscode !== undefined && d.disputestatuscode !== '' &&
          d.status !== null && d.status !== undefined && d.status !== '') {
          this.input = ({
            Status: d.status,
            DisputeStatusCode: d.disputestatuscode
          });
          this.getDisputeStatusNameAPICall(this.input, i);
        } else {
          this.listUserData[i].disputstatusname = '-'
        }
        i++;
      }
    },

    getDisputeStatusNameAPICall(input, i) {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'DisputeSubStatus',
        data: input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        this.listUserData[i].disputstatusname = result.data.data[0] ? result.data.data[0].pickupstatusname : '-'
      })
    },

    NewAwb(data) {
      newAWB(data, this.myStr).then(result => {
        result.data.data.forEach((status) => {
          this.listUserData.forEach((data, i) => {
            if (data.shippingid === status.shippingid) {
              this.listUserData[i]["newAWB"] = status.shippingid + 'REC';
              this.listUserData[i]["recreasionname"] = this.Recreasion(status.recreasonid)
            }
          });
        });
      });
    },

    Recreasion(data) {
      let RecReason;
      if (data !== null && data !== undefined) {
        RecReason = this.RECReasonMap[data]
      }
      return RecReason;
    },

    recReasonFetchData() {
      RecReasonData(this.myStr).then(result => {
        this.recreasons = result.data.data;
        this.recreasons.map((reasons) => {
          this.RECReasonMap[reasons.recreasonsid] = reasons.recreason
        });
      },
        error => {
          this.show = false;
          console.error(error)
        })
    },

    getregionname() {

      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {

        for (let i = 0; i < this.newhublist.length; i++) {
          if (this.listUserData[j]["hubzoneid"] !== null && this.listUserData[j]["hubzoneid"] != undefined) {

            if (this.newhublist[i]["hubzoneid"] == this.listUserData[j]["hubzoneid"]) {
              this.listUserData[j]["regionname"] = this.newhublist[i]["hubzonename"];

            }
          }
        }

      }

      this.editshowtable = true;
    },
    verificationStatusList() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {

        for (let i = 0; i < this.vStatusList.length; i++) {
          if (this.listUserData[j]["actionstatuscode"] !== null && this.listUserData[j]["actionstatuscode"] != undefined) {

            if (this.vStatusList[i]["investigationactionmasterid"] == this.listUserData[j]["actionstatuscode"]) {
              this.listUserData[j]["VerificationStatus"] = this.vStatusList[i]["actionname"];
            }
          }
        }

      }

      this.editshowtable = true;
    },
    Statusname() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'statusforstatusnames',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.StatusList2 = result.data.data;




        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.StatusList2.length; i++) {
            if (this.listUserData[j]["status"] !== null && this.listUserData[j]["status"] != undefined) {

              if (this.StatusList2[i]["statuscode"] == this.listUserData[j]["status"]) {
                this.listUserData[j]["Statusname"] = this.StatusList2[i]["statusname"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },

    getClientList() {

      axios({
        method: 'post',
        url: apiUrl.api_url + 'getClientList',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.clienList = result.data.data;

        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.clienList.length; i++) {
            if (this.listUserData[j]["clientid"] !== null && this.listUserData[j]["clientid"] != undefined) {

              if (this.clienList[i]["ClientMasterID"] == this.listUserData[j]["clientid"]) {
                this.listUserData[j]["Clientname"] = this.clienList[i]["CompanyName"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },

    //dropdown hub
    gethubdropdown() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'getHubdropdownlist',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        let finalHubData = []
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.HubID,
            label: hub.HubName
          })
        })
        this.hubdroplist = finalHubData;
        this.editshowtable = false;

        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j]["currenthubid"] !== null && this.listUserData[j]["currenthubid"] != undefined) {

              if (this.hubdroplist[i]["id"] == this.listUserData[j]["currenthubid"]) {
                this.listUserData[j]["currenthubname"] = this.hubdroplist[i]["label"];
              }
            }
          }
        }

        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j]["originhubid"] !== null && this.listUserData[j]["originhubid"] != undefined) {

              if (this.hubdroplist[i]["id"] == this.listUserData[j]["originhubid"]) {
                this.listUserData[j]["originhubname"] = this.hubdroplist[i]["label"];
              }
            }
          }
        }
        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j]["finaldestinationid"] !== null && this.listUserData[j]["finaldestinationid"] != undefined) {

              if (this.hubdroplist[i]["id"] == this.listUserData[j]["finaldestinationid"]) {
                this.listUserData[j]["finaldestinationname"] = this.hubdroplist[i]["label"];
              }
            }
          }
        }
        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j]["disputemarkedonhub"] !== null && this.listUserData[j]["disputemarkedonhub"] != undefined) {

              if (this.hubdroplist[i]["id"] == this.listUserData[j]["disputemarkedonhub"]) {
                this.listUserData[j]["disputemarkedonhubname"] = this.hubdroplist[i]["label"];
              }
            }
          }
        }

        this.editshowtable = true;

      },
        error => {
          console.error(error)
        })
    },
    //bucketcode
    getpendingat() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {

        for (let i = 0; i < this.pendingAtList.length; i++) {
          if (this.listUserData[j]["buckettypecode"] !== null && this.listUserData[j]["buckettypecode"] != undefined) {

            if (this.pendingAtList[i]["investigatbuckettypeid"] == this.listUserData[j]["buckettypecode"]) {
              this.listUserData[j]["bucketname"] = this.pendingAtList[i]["buckettypename"];

            }
          }
        }

      }

      this.editshowtable = true;


    },

    pendingDays() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {
        if (this.listUserData[j]["createddate"] !== null && this.listUserData[j]["createddate"] != undefined) {
          this.listUserData[j]["pendingdays"] = getNoOfDaysFromCurrentDate(moment(new Date(this.listUserData[j]["createddate"])).format("MM/DD/YYYY"))
        }

      }
      this.editshowtable = true;
    },
    buckettypecode() {

      axios({
        method: 'post',
        url: apiUrl.api_url + 'getinvestigationbuckettype',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.ListData = result.data.data;



        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.ListData.length; i++) {
            if (this.listUserData[j]["buckettypecode"] !== null && this.listUserData[j]["buckettypecode"] != undefined) {

              if (this.ListData[i]["investigatbuckettypeid"] == this.listUserData[j]["buckettypecode"]) {
                this.listUserData[j]["Buckettypename"] = this.ListData[i]["buckettypename"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    ImageView(awb1, status) {
      this.errormsg = ''
      this.abc = awb1;
      this.List = [];
      let path = '';
      this.primaryKey = 123;
      //console.log(awb1, primary, status);
      // if (status === 17 || status === 13) {
      //   path = `${awsBucketName}/STD/${awb1}`;
      // } else {
      //   path = `${awsBucketName}/${this.primaryKey}${awb1}`;
      // }
      path = `STD/${awb1}`;
      //console.log('path: ', path);
      this.input = ({
        key: path,
      });

      axios({
        method: 'post',
        url: `${apiUrl.api_url}getListObjectFroms3`,
        data: this.input,
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        const responseData = result.data || {};
        const bucketContents = Array.isArray(responseData.data && responseData.data.Contents)
          ? responseData.data.Contents
          : [];
        const irtImages = Array.isArray(responseData.irtproofs && responseData.irtproofs.images)
          ? responseData.irtproofs.images
          : [];

        const sortedBucketImages = bucketContents.length ? bucketContents.sort(custom_sort) : [];
        const normalizedIrtImages = irtImages.map((url) => ({ url, isDirectUrl: true }));

        this.List = [...sortedBucketImages, ...normalizedIrtImages].slice(0, 3);

        if (this.List.length <= 0 || responseData.statusCode == 101) {
          this.errormsg = "No Image Found"
        }
      });
    },

    goSummeryPage(awb) {
      const accessKey = createShipmentSummaryAccess(awb);
      window.open(this.$router.resolve({
        path: '/summerPage',
        query: { awb: awb, accessKey: accessKey }
      }).href, '_blank');
    },

    downloadImage(filePath) {
      // console.log(filePath);
      // this.imgData = filePath;
      if (typeof filePath === 'string' && /^https?:\/\//i.test(filePath)) {
        this.imgData = filePath;
        this.showModal = true;
        return;
      }

      this.show1 = true;
      this.input = ({
        key: filePath,
        fileName: 'download.png',
      });

      axios({
        method: 'post',
        url: `${apiUrl.api_url}fetchImages3`,
        data: this.input,
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        this.show1 = false;
        //console.log('result from fetch api', result);
        const finalImage = result.data.ImageData.Body.data;
        let buff = new Buffer.from(finalImage);
        let base64data = buff.toString('base64');
        this.imgData = 'data:image/png;base64,' + base64data
        // console.log('finalImage: ', toBase64(finalImage));
      });


      this.showModal = true;
    },
    closeImage() {
      this.showModal = false;
    },

    exportfileCSV() {
      this.awbnumber = AWBNumberNormslization(this.awbnumber).toString();

      if (!this.validateSearchFilters()) {
        return;
      }

      this.show2 = true;
      const exportPayload = this.buildSearchPayload(0, {
        includePagination: false,
        exportData: true
      });

      axios({
        method: 'post',
        url: apiUrl.api_url + 'searchinvestigationshipmentData',
        data: exportPayload,
        responseType: 'arraybuffer',
        headers: {
          'Authorization': 'Bearer ' + this.myStr,
          'Content-type': 'application/json'
        }
      }).then((response) => {
        this.show2 = false;

        if (!response.data || response.data.byteLength === 0) {
          this.$alertify.error('No data Found');
          return;
        }

        this.downloadCSV(response.data, this.getExportFileName());
      },
      (error) => {
        this.show2 = false;
        console.error(error);
        this.$alertify.error('Failed to export data');
      });
    },

    getExportFileName() {
      return `investigationDefault${moment(new Date()).format("YYYY-MM-DD_HH-mm-ss")}.xlsx`;
    },

    downloadCSV(fileData, filename) {
      const blob = new Blob([fileData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename || 'investigationDefault.xlsx');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    showMpsDetails(mpsID) {
      // console.log(filePath);
      // this.imgData = filePath;
      this.isMpsDetails = true;
      this.isMpsDetailsLoading = true;
      this.input = ({
        mpsID: mpsID,
      });

      mpsDetails(this.input, this.myStr).then(result => {
        console.log(result);
        this.isMpsDetailsLoading = false;
        this.mpsDetailsShipments = result.data.data;
      })
      


      this.isMpsDetails = true;
    },

    closeMpsDetails(){
      this.isMpsDetails = false;
    },

    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      //columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      //keys = Object.keys(data[0]).slice(0);
      columnDelimiter = "ShippingID,ClientName,OctrioMRP,hubzoneid,HubZoneName,CurrentHubName,OriginHubid,OriginHubName,DestinationHubName,DisputeSatusName,Requestfrom,CreatedBy,OrderType,PhysicalWeight,VolumetricWeight,LoggedDate,LoggedDescription,ColoaderName,BagCondition,Contents,StatusName,VerificationStatus,STDBagCondition,PendingDays,verifieddate,verifieddescription,approvaldate,approvaldescription,lastmodifiedby,ManifestInScanDate,shortagetype,bagno,recreasionname";
      result = "";
      result += columnDelimiter;
      result += lineDelimiter;
      for (let i = 0; i < data.length; i++) {
        result += (data[i].shippingid).toString() + ',' + data[i].Clientname + ',' + data[i].netvalue + ',' + data[i].hubzoneid + ',' + data[i].hubzonename + ',' + data[i].currenthubname + ',' + data[i].originhubid + ',' + data[i].originhubname + ',' + data[i].finaldestinationname + ',' + data[i].disputstatusname + ',' + data[i].Buckettypename + ',' + data[i].createdby + ',' + data[i].ordertype + ',' + data[i].phyweight + ',' + data[i].volweight + ',' + moment(new Date(data[i].createddate)).format("DD/MM/YYYY") + ',' + data[i].loggeddescription + ',' + data[i].coloaderid + ',' + data[i].stdbagcondition + ',' + data[i].productinformation + ',' + data[i].Statusname + ',' + data[i].VerificationStatus + ',' + data[i].stdbagcondition + ',' + data[i].pendingdays + ',' + moment(new Date(data[i].verifieddate)).format("DD/MM/YYYY") + ',' + data[i].verifieddescription + ',' + data[i].approvaldate + ',' + data[i].approvaldescription + ',' + data[i].lastmodifiedby + ',' + moment(new Date(data[i].createddate)).format("DD/MM/YYYY") + ',' + data[i].shortagetype + ',' + data[i].bagno + ',' + data[i].recreasionname;

        result += lineDelimiter;


      }
      return result;
    },
    sortTable(column, direction) {
      this.sortColumn = column;
      this.sortDirection = direction;
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/investigationDefault/investigationDefault.component.js